<template>
    <SkipAction>
        <template v-slot="{ skip }">
            <Action @click="skip()" icon="sr-2 sr-v2-eye-slashed" text="Skip" />
        </template>
    </SkipAction>
</template>

<script>
import Action from '../Action'
import SkipAction from '@/components/AthleteProfile/SkipAction'
import { mapActions } from 'vuex'

export default {
    components: { Action, SkipAction },
}
</script>
